import { BasePaper } from "@/shared/ui/base-paper";
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import type React from "react";

export type DeliveryProposalFormTableRow = {
  title: string;
  cells: React.ReactNode[];
};
export type DeliveryProposalFormTableProps = {
  headers: string[];
  rows: DeliveryProposalFormTableRow[];
};
export const DeliveryProposalFormTable: React.FC<
  DeliveryProposalFormTableProps
> = ({ headers, rows }) => {
  const theme = useTheme();
  return (
    <TableContainer component={BasePaper}>
      <Table>
        <TableHead sx={{ backgroundColor: theme.palette.grey[50] }}>
          <TableRow>
            <TableCell sx={{ width: 160 }} />
            {headers.map((header) => (
              <TableCell key={header} sx={{ minWidth: 240 }}>
                <Typography variant="body2">{header}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.title}>
              <TableCell>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {row.title}
                </Typography>
              </TableCell>
              {row.cells.map((cell, cellIndex) => (
                <TableCell key={`${row.title}-cell-${cellIndex}`}>
                  {typeof cell === "string" ? (
                    <Stack>
                      <Typography
                        variant="body1"
                        sx={{ whiteSpace: "pre-line" }}
                      >
                        {cell}
                      </Typography>
                    </Stack>
                  ) : typeof cell === "number" ? (
                    <Typography variant="body1">{cell}</Typography>
                  ) : (
                    cell
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
